(function() { window.GUID_cf35e133_6439_4859_8edc_08941d653882 = { getGuid: function() { return "cf35e133-6439-4859-8edc-08941d653882"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class GridViewFixedHeaderHelper {
            static Start(gridView) {
                if (!this.GridViews) {
                    this.GridViews = new Array();
                    CS.DOM.$win.offon('scroll.gridviewfixedheader', function () {
                    });
                }
                this.GridViews.push(new GridViewFixedHeader(gridView));
            }
        }
        Controls.GridViewFixedHeaderHelper = GridViewFixedHeaderHelper;
        class GridViewFixedHeader {
            constructor(gridView) {
                this.GridViews = gridView;
            }
        }
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=gridview-fixed-header.js.map
